import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import { isVue2 } from 'vue-demi';
import { patchComponent, useSlots } from '../_use';
import { uniqueKey } from '../_util/index';
import { makeStringProp, makeNumberProp } from '../_util/props';
import { createBEM } from '../_util/bem';
import { PortalMixin } from '../_mixin/portal';
import UiLoading from '../loading';
import UiIcon from '../icon';
import { ICON_TOAST_SUCCESS_48, ICON_TOAST_WARN_48, ICON_TOAST_ERROR_48, ICON_TOAST_TIPS_48, ICON_CLOSE_12 } from '@futuweb/future-icon';
import VcTransition from '../vc-transition';
import { isServer } from '../_util/is-server';
const bem = createBEM('ui-toast');
UiIcon.add([ICON_TOAST_SUCCESS_48, ICON_TOAST_WARN_48, ICON_TOAST_ERROR_48, ICON_TOAST_TIPS_48, ICON_CLOSE_12]);
const toastProps = {
  type: makeStringProp('msg'),
  position: makeStringProp('middle'),
  message: String,
  dangerouslyUseHTMLString: Boolean,
  // 这里是为了配合r-message才搞得，没写接口上，尽量别让业务使用它
  visible: {
    type: Boolean,
    default: false
  },
  duration: makeNumberProp(2000),
  toastClass: String,
  toastStyle: Object,
  transition: String,
  teleport: {
    type: [Function, Boolean, String],
    default: null
  },
  icon: String,
  notice: {
    type: Boolean,
    default: false
  },
  forbidClick: {
    type: Boolean,
    default: false
  },
  closable: {
    type: Boolean,
    default: false
  },
  onOpen: {
    type: Function,
    default: () => {}
  },
  onClose: {
    type: Function,
    default: () => {}
  }
};
export default patchComponent({
  name: 'UiToast',
  mixins: [PortalMixin()],
  components: {
    UiLoading,
    VcTransition,
    UiIcon
  },
  data() {
    const id = uniqueKey('ui-toast');
    return {
      show: false,
      closeTimer: 0,
      id
    };
  },
  props: toastProps,
  model: {
    prop: 'visible',
    event: 'update:visible'
  },
  watch: {
    visible: {
      handler(val) {
        if (isServer()) return;
        val ? this.open() : this.close();
      },
      immediate: true
    }
  },
  methods: {
    open() {
      var _this$onOpen;
      document.body.classList[this.forbidClick ? 'add' : 'remove']('disabled');
      this.closeTimer && clearTimeout(this.closeTimer);
      this.show = true;
      if (this.duration) {
        this.closeTimer = window.setTimeout(this.close, this.duration);
      }
      this === null || this === void 0 || (_this$onOpen = this.onOpen) === null || _this$onOpen === void 0 || _this$onOpen.call(this, this);
    },
    close() {
      this.show = false;
      this.forbidClick && document.body.classList.remove('disabled');
      this.$emit('update:visible', false);
      this.closeTimer && clearTimeout(this.closeTimer);
    },
    onAfterLeave() {
      this.onClose(this);
    },
    renderIcon() {
      var _slots$icon;
      const h = this.$createElement;
      const slots = useSlots(this);
      const slotIcon = slots === null || slots === void 0 || (_slots$icon = slots.icon) === null || _slots$icon === void 0 ? void 0 : _slots$icon.call(slots);
      if (slotIcon) {
        return slotIcon;
      } else if (this.type !== 'msg' || this.icon) {
        const iconMap = {
          success: 'icon_toast_success_48',
          error: 'icon_toast_error_48',
          info: 'icon_toast_tips_48',
          warning: 'icon_toast_warn_48'
        }; // 用来展示success、fail的icon
        if (this.type === 'loading') {
          return h(UiLoading, {
            "attrs": {
              "color": "white",
              "tip": this.message
            }
          });
        } else {
          var _this$icon;
          return this !== null && this !== void 0 && (_this$icon = this.icon) !== null && _this$icon !== void 0 && _includesInstanceProperty(_this$icon).call(_this$icon, '/') ? h("img", {
            "attrs": {
              "src": this.icon
            }
          }) : h(UiIcon, {
            "class": bem('icon'),
            "attrs": {
              "name": this.icon || iconMap[this.type],
              "size": "48px"
            }
          });
        }
      }
    },
    renderContent() {
      var _slots$default;
      const h = this.$createElement;
      const slots = useSlots(this);
      const useSlot = !!((_slots$default = slots.default) !== null && _slots$default !== void 0 && _slots$default.call(slots));
      const {
        message
      } = this;
      if (this.dangerouslyUseHTMLString) {
        return isVue2 ? h("div", {
          "domProps": {
            "innerHTML": message
          },
          "class": bem('content')
        }) : h("div", {
          "directives": [{
            name: "html",
            value: message
          }],
          "class": bem('content')
        });
      } else {
        if (useSlot) {
          var _slots$default2;
          return (_slots$default2 = slots.default) === null || _slots$default2 === void 0 ? void 0 : _slots$default2.call(slots);
        } else {
          if (this.type !== 'loading') {
            return h("p", {
              "class": bem('content')
            }, [message]);
          }
          return '';
        }
      }
    }
  },
  render() {
    const h = arguments[0];
    const iconContent = this.renderIcon();
    const name = this.transition || (this.notice ? 'toast-notice-fade' : "toast-fade-".concat(this.position));
    return h(VcTransition, {
      "attrs": {
        "name": name
      },
      "on": {
        "afterLeave": this.onAfterLeave
      }
    }, [h("div", {
      "class": [bem('', {
        top: this.position === 'top',
        bottom: this.position === 'bottom',
        'notice-type': this.notice,
        'with-icon': !!iconContent,
        closable: this.closable
      }), this.toastClass],
      "style": this.toastStyle,
      "attrs": {
        "id": this.id,
        "role": "alert"
      },
      "directives": [{
        name: "show",
        value: this.show
      }]
    }, [iconContent, this.renderContent(), this.closable && h(UiIcon, {
      "attrs": {
        "role": "button",
        "aria-label": "close",
        "tabindex": 0,
        "name": "icon_close_12",
        "size": "12px"
      },
      "class": bem('close-icon'),
      "on": {
        "click": this.close
      }
    })])]);
  }
});